<template>
  <v-menu rounded bottom offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" dark style="text-transform: none">
        <v-icon color="white" class="mr-1">mdi-account-circle</v-icon>
        <span class="white--text mr-4">
          <strong>{{ userName || '名無し' }}</strong>
        </span>
      </v-btn>
    </template>
    <v-card>
      <v-container>
        <h5>メールアドレス: {{ email }}</h5>
        <h5>電話番号: {{ tel }}</h5>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';

@Component
export default class UserAccountMenu extends Vue {
  get email(): string {
    return Store.getters.email;
  }
  get userName(): string {
    return Store.getters.userName;
  }
  get tel(): string {
    return Store.getters.tel;
  }
}
</script>
